<template>
    <div class="main">
        <el-dialog
            :title="openData.title"
            :visible.sync="openData.state"
            :close-on-click-modal="false"
            width="700px"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    :disabled="openData.title == '详情'"
                    label-position="left"
                    label-width="110px"
                    ref="formData"
                    :model="formData"
                    :rules="formDataRules"
                >
                    <el-form-item label="地址编号：" prop="serviceTitle">
                        <el-input
                            disabled
                            v-model.trim="formData.serviceTitle"
                            placeholder=""
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="上级地址：" prop="serviceDepartment">
                        <el-select
                            disabled
                            v-model="formData.belongSocialOrgId"
                            placeholder="请选择上级地址"
                            style="width: 100%"
                        >
                            <!-- orgList -->
                            <el-option
                                v-for="item in orgList"
                                :key="item.id"
                                :label="item.label"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="地址名称：" prop="serviceTitle">
                        <el-input
                            disabled
                            v-model.trim="formData.serviceTitle"
                            placeholder="请输入地址名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="类型级别：" prop="serviceDepartment">
                        <el-select
                            disabled
                            v-model="formData.belongSocialOrgId"
                            placeholder="请选择类型级别"
                            style="width: 100%"
                        >
                            <!-- orgList -->
                            <el-option
                                v-for="item in levelList"
                                :key="item.id"
                                :label="item.label"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="负责人：" prop="serviceTitle">
                        <el-input
                            disabled
                            v-model.trim="formData.serviceTitle"
                            placeholder="请输入负责人"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="联系方式：" prop="serviceTitle">
                        <el-input
                            disabled
                            v-model.trim="formData.serviceTitle"
                            placeholder="请输入联系方式"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="状态：" prop="serviceTitle">
                        <el-radio-group v-model="formData.isEnable">
                            <el-radio label="0">启用</el-radio>
                            <el-radio label="1">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <div
                slot="footer"
                class="dialog-footer dialog-footer-btn"
                v-if="openData.title != '详情'"
            >
                <el-button type="primary" @click="handleSubmit"
                    >确 定</el-button
                >
                <el-button @click="dialogVisibleClone">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ["openData"],
    data() {
        return {
            formData: {},
            formDataRules: {},
            orgList: [],
            levelList: [],
        }
    },
    created() {},
    methods: {
        handleSubmit() {
            this.$emit("cancleAddress", true)
        },
        dialogVisibleClone() {
            this.$emit("cancleAddress", false)
        },
    },
}
</script>
<style lang="less" scoped>
</style>